// getters and setters
function get__viewportW() {
    vw = $(window).width();
    return vw;
}
function get__navHeight() {
    hn = document.querySelector('.navbar').parentElement.clientHeight;
    return hn;
}
function get__page() {
    var fullUrl = window.location.href.split('/').reverse()[0];
    var testHash = fullUrl.split('#');
    if (testHash !== fullUrl) {
        fullUrl = testHash[0];
    }
    if ($.inArray(fullUrl, ['', undefined, null, 'home']) >= 0) {
        fullUrl = 'home';
    }
    return fullUrl;
}
function get__hash() {
    var hashOfThePage = window.location.hash;
    if ($.inArray(hashOfThePage, ['', undefined, null]) >= 0) {
        hashOfThePage = 'noHash';
    }
    return hashOfThePage;
}

function initGettersAndSetters() {
    get__viewportW();
    get__navHeight();
    get__page();
    get__hash();
    console.log('Page: ' + get__page() + ' | Hash: ' + get__hash());
}

// Identifica direcao do scroll
function scrollDirection() {
    var scrollInit = 0;
    $(window).on('scroll', function () {
        var scrollBody = $(this).scrollTop();
        if (scrollBody < scrollInit) {
            $('body').removeClass('hidden');
            $('body').addClass('scrolledUp');
            $('body').removeClass('scrolledDown');
        } else {
            $('body').removeClass('scrolledUp');
            $('body').addClass('scrolledDown');
        }
        scrollInit = scrollBody;
    });
}
// Example:
// $(window).on('load', function() {scrollDirection();});


// link scroll
function goToSection__scroll(elScrollDestiny, distanceIfScrollGoingToUp, distanceIfScrollGoingToDown, speedScroll, delay) {
    console.clear();
    // scroll reference
    var scrollEfetuado = $(window).scrollTop();
    console.log(scrollEfetuado);
    // element reference
    var sectionDestiny_offsetTop = $(elScrollDestiny).offset().top;
    console.log(elScrollDestiny);
    console.log(sectionDestiny_offsetTop);

    if (scrollEfetuado > sectionDestiny_offsetTop) {
        console.log('vai subir');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToUp
            }, speedScroll);
        }, delay);
    } else {
        console.log('vai descer');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToDown
            }, speedScroll);
        }, delay);
    }
}
// Example:
// $('.js-linkScroll').on('click', function(e) {
//     e.preventDefault();
//     var finalDestiny = $(this).attr('href');
//     goToSection__scroll(finalDestiny, 100, 50, 700, 10);
// });

$(window).on('load', function () {
    scrollDirection();
    initGettersAndSetters();
});
$(window).on('hashchange', function () {
    initGettersAndSetters();
});

if ($('.auxElements__controls').length) {
    function identifyScroll() {
        returnScroll = 1;
        if ($('body').hasClass('scrolledDown')) {
            returnScroll = 'Down';
        } else if ($('body').hasClass('scrolledUp')) {
            returnScroll = 'Up';
        } else {
            returnScroll = 'Static';
        }
        return returnScroll;
    }
    function tasksAuxVars() {
        $('.auxElements__controls .scrollEfetuado').html(Math.round($(window).scrollTop()));
        $('.auxElements__controls .scrollDirection').html(identifyScroll());
        $('.auxElements__controls .viewportWidth').html(Math.round($(window).width()));
        $('.auxElements__controls .viewportHeight').html(Math.round($(window).height()));
        $('.auxElements__controls .navHeight').html(Math.round(get__navHeight()));
    }

    $(document).on('ready', function () {
        tasksAuxVars();
    });
    $(window).on('load', function () {
        tasksAuxVars();
    });
    $(window).on('resize', function () {
        tasksAuxVars();
    });
    $(window).on('scroll', function () {
        tasksAuxVars();
    });
}
$('input, form').attr('autocomplete', 'off');

$(document).on('click', '.toggle-password', function () {
    var input = $("#input-password");
    if (input.attr("type") === "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

/**
 * SELECT 2
 */
if ($('.js-select2').length) {
    //select2Init('regioes');
}

function select2Init(sourceField) {
    var targetData = sourceField.attr('data-id-target');
    console.log(targetData);
    var el = $('.js-select2-' + targetData);
    var refresh = el.attr('data-refresh-target');

    if (refresh == 'yes' && el.hasClass("select2-hidden-accessible")) el.select2('destroy');

    el.select2({
        ajax: {
            url: targetData + '/select2',
            dataType: 'json',
            method: 'post',
            context: this,
            data: function (params) {
                if (targetData == 'regioes') {
                    var query = {
                        search: params.term,
                        type: 'public',
                        estado: sourceField.val()
                    }
                } else if (targetData == 'cidades-regiao') {
                    var query = {
                        search: params.term,
                        type: 'public',
                        regiao: sourceField.val()
                    }
                }
                // Query parameters will be ?search=[term]&type=public
                return query;
            }
        },
        minimumInputLength: 3,
        placeholder: "Selecione",
        "language": {
            errorLoading: function () {
                return 'Os resultados não foram ser carregados.';
            },
            searching: function () { return 'Buscando…'; },
            "noResults": function () { return 'Nenhum item encontrado'; },
            inputTooShort: function (args) {
                var remainingChars = args.minimum - args.input.length;
                var message = 'Digite ' + remainingChars + ' ou mais caracteres';
                return message;
            },
        }
    });
}

/**
 * Carrega as cidades de um estado
 */
$(document).on('change', '.load-cidades', function (e) {
    e.preventDefault();

    var target = '#' + $(this).attr('data-id-target');
    var pk = $('option:selected', this).val();

    $(target).html('<option>Carregando ...</option>');
    $.ajax({
        type: "POST",
        data: { estado: pk },
        context: this,
        url: "cidades/select",
        success: function (result) {
            $(target).html(result);
        }
    });
});

/**
* Carrega as cidades de uma região
*/
$(document).on('change', '.load-cidades-regiao', function (e) {
    e.preventDefault();
    if ($(this).hasClass('js-select2')) {
        select2Init($(this));
    } else {
        var target = '#' + $(this).attr('data-id-target');
        var refresh = $(this).attr('data-refresh-target');
        var pk = $('option:selected', this).val();

        $(target).html('<option>Carregando ...</option>');
        $.ajax({
            type: "POST",
            data: { regiao: pk },
            context: this,
            url: "cidades-regiao/select",
            success: function (result) {
                $(target).html(result);

                if (refresh == 'yes')
                    $('.selectpicker').selectpicker('refresh');
            }
        });
    }
});

/**
 * Carrega as regiões de um estado
 */
$(document).on('change', '.load-regioes', function (e) {
    e.preventDefault();
    if ($(this).hasClass('js-select2'))
        select2Init($(this));
    else {
        var target = '#' + $(this).attr('data-id-target');
        var pk = $('option:selected', this).val();

        $(target).html('<option>Carregando ...</option>');
        $.ajax({
            type: "POST",
            data: { estado: pk },
            context: this,
            url: "regioes/select",
            success: function (result) {
                $(target).html(result);
            }
        });
    }
});

/**
* MASCARAS DE CAMPOS
*/
$(document).on("focus", ".maskHora", function () {
    $('.maskHora').mask('00:00');
});
$(document).on("focus", ".maskDataHora", function () {
    $('.maskDataHora').mask('00/00/0000 00:00');
});
$(document).on("focus", ".maskData", function () {
    $('.maskData').mask('00/00/0000', { reverse: true });
});
$(document).on("focus", ".maskCEP", function () {
    $('.maskCEP').mask('00000-000', { reverse: true });
});
$(document).on("focus", ".maskValor", function () {
    var mask = '000.000,00';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskValor').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskDecimal", function () {
    var mask = '0000,00';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskDecimal').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskNumber", function () {
    var mask = '0000';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskNumber').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskCPF", function () {
    $('.maskCPF').mask('000.000.000-00', { reverse: true });
});
$(document).on("focus", ".maskCNPJ", function () {
    $('.maskCNPJ').mask('00.000.000/0000-00', { reverse: true });
});
$(document).on("focus", ".maskTelefone", function () {
    var TelefoneMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(99) 00000-0000' : '(99) 0000-00009';
    },
        spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(TelefoneMaskBehavior.apply({}, arguments), options);
            }
        };
    $('.maskTelefone').mask(TelefoneMaskBehavior, spOptions);
});

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

/**
* ATIVO INATIVO NAS LISTAS DE REGISTROS
* Uso:
* <label class="form-check form-switch mb-0 d-inline-block">
*     <input class="form-check-input form-ativo" name="ativo" value="S" data-tipo="segmento" data-codigo="<?php echo md5($row['codigo']); ?>" type="checkbox" <?php echo ($row['ativo']=='S') ? 'checked' : ''; ?> >
* </label>
*/
$('.form-ativo').change(function () {
    var tipo = $(this).attr('data-tipo') + "/situacao";
    var codigo = $(this).attr('data-codigo');
    var novo_valor = '';
    if (this.checked) {
        novo_valor = 'S';
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        novo_valor = '';
    }

    $.ajax({
        type: "POST",
        url: tipo,
        context: this,
        data: { codigo: codigo, valor: novo_valor, acao: tipo },
        success: function (result) {
            //$('.row-images-cards').html(result);
        }
    });
});

/**
 * ALERTA RAPIDO TOP RIGHT
 */
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

function toastFire(response, Toast) {
    response = response.split('|');
    Toast.fire({
        icon: (response[0] == 1) ? 'success' : 'error',
        title: response[1]
    });
    return true;
}

/**
 * X-EDITABLE
 */
function startXEditable() {
    if ($('.textDisable').length) {
        $('.textDisable').editable({
            showbuttons: false,
            placement: 'left',
            inputclass: 'input-disabled',
            tpl: '<textarea readonly></textarea>'
        });
    }

    if ($('.upd-text').length) {
        $('.upd-text').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-textarea').length) {
        $('.upd-textarea').editable({
            emptytext: 'Editar',
            inputclass: 'form-control',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-decimal').length) {
        $('.upd-decimal').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            inputclass: 'maskDecimal',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-date').length) {
        $('.upd-date').editable({
            emptytext: 'Editar',
            format: 'yyyy-mm-dd',
            viewformat: 'dd/mm/yyyy',
            datepicker: {
                weekStart: 0
            },
            clear: '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-event" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><rect x="4" y="5" width="16" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="4" y1="11" x2="20" y2="11"></line><rect x="8" y="15" width="2" height="2"></rect></svg> Hoje',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-select').length) {
        $('.upd-select').editable({
            emptytext: 'Editar',
            mode: 'popup',
            inputclass: 'form-select',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });

        $('.upd-select').on('save', function (e, params) {
            console.log('Saved value: ' + params.newValue);
        });
    }

    if ($('.upd-ativo').length) {
        $('.upd-ativo').editable({
            mode: 'popup',
            success: function (response, newValue) {
                if (newValue === 'N') {
                    $(this).removeClass('label-success').addClass('label-danger');
                } else {
                    $(this).removeClass('label-danger').addClass('label-success');
                }
                toastFire(response, Toast);
            }
        });
    }
};
startXEditable();

/**
 * DRAG & DROP DOS ARQUIVOS
 */
var fileActionSettingsArray = {
    removeIcon: '<i class="ti ti-trash"></i>',
    uploadIcon: '<i class="ti ti-cloud-upload"></i>',
    uploadRetryIcon: '<i class="ti ti-rotate-clockwise"></i>',
    downloadIcon: '<i class="ti ti-download"></i>',
    zoomIcon: '<i class="ti ti-zoom-in"></i>',
    dragIcon: '<i class="ti ti-arrows-move"></i>',
    indicatorNew: '<i class="ti ti-plus-lg text-warning"></i>',
    indicatorSuccess: '<i class="ti ti-check-lg text-success"></i>',
    indicatorError: '<i class="ti ti-exclamation-lg text-danger"></i>',
    indicatorLoading: '<i class="ti ti-hourglass-bottom text-muted"></i>',
    indicatorPaused: '<i class="ti ti-pause-fill text-primary"></i>',
};
var previewZoomButtonIconsArray = {
    prev: '<i class="ti ti-chevron-left"></i>',
    next: '<i class="ti ti-chevron-right"></i>',
    toggleheader: '<i class="ti ti-maximize"></i>',
    fullscreen: '<i class="ti ti-arrows-maximize"></i>',
    borderless: '<i class="ti ti-layout-navbar"></i>',
    close: '<i class="ti ti-x"></i>'
}
function uploadFiles() {
    $("#uploadFiles").fileinput({
        language: 'pt-BR',
        uploadUrl: "upload",
        uploadAsync: false,
        maxFileCount: 20,
        showClose: false,
        fileActionSettings: fileActionSettingsArray,
        previewZoomButtonIcons: previewZoomButtonIconsArray,
        allowedFileExtensions: ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'svg', 'mp3', 'aac', 'ogg', 'wma', 'wav', 'mp4', 'mov', 'wmv', '3gp', 'rm', 'avi'],
        maxFileSize: 204800,
        uploadExtraData: function () {
            return {
                avaliacao: $("#avaliacao").val()
            };
        }
    }).on('filebatchuploadcomplete', function (event, files, extra) {
        if ($('#formChecklist').length) {
            $('#formChecklist').submit();
        } else {
            $('#modalArquivos').modal('toggle');
        }
    });
}

/**
 * MODAL
 */
$(document).on('click', '.btn-modal', function (e) {
    e.preventDefault();
    var modal = $(this).attr('href');
    var codigo = $(this).attr('data-codigo');
    $.post(modal,
        { codigo: codigo },
        function (resultado) {
            $('body').append(resultado);
            $('#modal').modal('show');

            $('#modal').on('shown.bs.modal', function (e) {
                startXEditable();
                if ($('#uploadFiles').length) uploadFiles();
            });

            $('#modal').on('hidden.bs.modal', function (e) {
                $('#modal').remove();
            });
        });
});

// Pega o maior valor de z-index no DOM
function getMaxZIndex() {
    return Math.max(
        ...Array.from(document.querySelectorAll('body *'), el =>
            parseFloat(window.getComputedStyle(el).zIndex),
        ).filter(zIndex => !Number.isNaN(zIndex)),
        0,
    );
}

/**
 * OFFCANVAS
 */
$(document).on('click', '.btn-offcanvas', function (e) {
    e.preventDefault();
    $('#offcanvas').offcanvas('hide');
    var offcanvas = $(this).attr('href');
    var codigo = $(this).attr('data-codigo');
    $.post(offcanvas,
        { codigo: codigo },
        function (resultado) {
            $('body').append(resultado);

            $('#offcanvas').offcanvas('show');
            $('.offcanvas-backdrop').css('z-index', getMaxZIndex() + 1);
            $('#offcanvas').css('z-index', getMaxZIndex() + 2);

            $('#offcanvas').on('shown.bs.offcanvas', function (e) {
                startXEditable();
                $('[data-bs-toggle="tooltip"]').tooltip();
            });

            $('#offcanvas').on('hidden.bs.offcanvas', function (e) {
                $('#offcanvas').remove();
            });
        });
});

$(document).on('click', '#formDefault .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        var redirect = btn.attr('data-redirect');
                        if (redirect)
                            location.href = redirect;
                        else
                            location.reload();
                    });
                } else {
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

/* PAGE-PRODUTO.PHP */
/* ZOOM IMAGEM */
function easyZoom() {
    // Instantiate EasyZoom instances
    var $easyzoom = $('.easyzoom').easyZoom();
    // Get an instance API
    var api = $easyzoom.data('easyZoom');
}

if ($('.easyzoom').length) {
    easyZoom();
}

$(document).on('click', '.btn-galeria', function (e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo'); // codigo do produto
    var cor = $(this).attr('data-cor'); // codigo da cor
    $.post('produto/galeria',
        { codigo: codigo, cor: cor, ajax: true },
        function (resultado) {
            $('#galeria-produto').html(resultado);
            $('[data-bs-toggle="tooltip"]').tooltip();
            //$('.btn-galeria [data-bs-toggle="tooltip"]').enable();
            easyZoom();
        });
});

// calculo do valor do subsidio
function calculaValorSubsidio() {
    var largura = parseFloat($('.input-largura').val().replace(',', '.').replace(' ', ''));
    var altura = parseFloat($('.input-altura').val().replace(',', '.').replace(' ', ''));
    var valorMaterial = parseFloat($('.select-tipo-material option:selected').attr('data-valor'));
    var tipoCalculo = $('.select-tipo-material option:selected').attr('data-tipo-calculo');
    var valorSubsidio = 0;
    if (!isNaN(largura) && !isNaN(altura) && !isNaN(valorMaterial)) {
        if (tipoCalculo == 'U') {
            valorSubsidio = valorMaterial;
        } else {
            valorSubsidio = largura * altura * valorMaterial;
        }
        $('.input-valor-subsidio').val(valorSubsidio.toLocaleString('pt-br', { style: 'decimal', maximumFractionDigits: 2,  mininumFractionDigits: 2 }));
    } else {
        $('.input-valor-subsidio').val('');
    }
}
$(document).on('change', '.select-tipo-material', function () {
    calculaValorSubsidio()
});
$(document).on('change', '.input-largura, .input-altura', function () {
    calculaValorSubsidio()
});
$(document).on('click', '#btnCheckCNPJCliente', function(e) {
    e.preventDefault();
    var cnpj = $('.input-cnpj').val();

    if (cnpj=='') {
        Swal.fire({
            title: 'Informe o seu CPNJ',
            icon: 'info',
            timer: 3000,
            showConfirmButton: false,
            allowOutsideClick: false
        });
    } else {
        $.ajax({
            type: "POST",
            data: {cnpj: cnpj, acao: 'check-cnpj'},
            url: "cadastro/check-cnpj",
            success: function (result) {
                result = result.split('|');
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('.dadosCliente').remove();
                        $('.inputCNPJ').after(result[3]);
                    });
                } else {
                    $('.input-cnpj').val('');
                    $('.dadosCliente').remove();
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                }
            }
        });
    }
});

$(document).on('click', '#formCadastroCliente .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[1]) == 1){
                    Swal.fire({
                        title: result[2],
                        text: 'Muito obrigado pelo cadastro. Em breve entraremos em contato!',
                        icon: 'success',
                        timer: 5000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = './';
                    });
                }else{
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html('Finalizar cadastro').attr('disabled', false);
                    });
                }
            }
        });
    }
});
$(document).on('click', '#formCidades .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirCidades', function(e) {
    e.preventDefault();
    confirmaExcluir("cidades/excluir", $(this).attr('data-codigo'));
});
$(document).on('click', '.formCliente .btnSave', function (e) { // OK
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[0]) == 1) {
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.reload();
                    });
                } else {
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '#formSenha .btnSave', function (e) { // OK
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();

    if (form.smkValidate()) {
        //SUBMIT form
        if (($('#novasenha').val() == $('#confirmasenha').val()) && $('#novasenha').val() != '') {
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[1]) == 1) {
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $("input[type='password']").val('');
                            btn.html(btnTextoOriginal).attr('disabled', false);
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            btn.html(btnTextoOriginal).attr('disabled', false);
                        });
                    }
                }
            });
        } else {
            toastFire('0|As senhas informadas são diferentes', Toast);
        }
    }
});
$(document).on('click', '#formEstados .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirEstados', function(e) {
    e.preventDefault();
    confirmaExcluir("estados/excluir", $(this).attr('data-codigo'));
});
function isInt(n){
    return Number(n) === n && n % 1 === 0;
}

function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}

function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function validaCPF(CPF) {
    var erro = 0;
    var Soma;
    var Resto;
    var strCPF = CPF.replace(".", ""); //tira ponto
    strCPF = strCPF.replace(".", ""); //tira o segundo ponto
    strCPF = strCPF.replace("-", ""); //tira hífen
    Soma = 0;
    if (strCPF == "00000000000") erro = 1;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;
    Soma = 0;
    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;
    if (erro == 0) {
        return true;
    } else {
        return false;
    }
}

function validaCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14)
        return false;
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;
    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;
    return true;
}

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

function copyToClipBoard(fieldId) {
    // Get text
    var txt = $('#'+fieldId).text();
    // Create new element
    console.log(txt);
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = txt;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = {
        position: 'absolute',
        left: '-9999px'
    };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
    toastFire('1|Texto copiado para a área de transferência', Toast)
    return false;
}

function confirmaExcluir(pUrl, pCodigo, pRowPrefix) {
    var row = (pRowPrefix) ? pRowPrefix : 'row';
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas a este registro!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#206bc4',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "POST",
                data: {codigo: pCodigo}, //pCodido em enc()
                url: pUrl,
                success: function (response) {
                    result = response.split('|');
                    console.log(pCodigo, response, result);
                    if (parseInt(result[0]) == 1) {
                        $('#' + row + pCodigo).remove();
                        toastFire(response, Toast);
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });

}
$(document).on('click', '#btnLogin', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        form.ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Autenticando').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.href = 'home';
                    });
                } else {
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    };
});

$(document).on('click', '#formGeraLinkSenha .btnSave, #formNovaSenha .btnSave, #formSolicitaAcesso .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[1]) == 1){
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }else{
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});
function calculaGrade(produto, cor, tamanho, qtdeDigitada, qtdeEstoque, preco) {
    // Calcula total por cor
    var qtdeTotalCor = 0;
    var valorTotalCor = 0;
    var qtdeDigitada = parseInt((qtdeDigitada) ? qtdeDigitada : 0);
    var qtdeEstoque = parseInt((qtdeEstoque) ? qtdeEstoque : 0);

    console.log(produto, cor, tamanho, qtdeDigitada, qtdeEstoque, preco);

    if (qtdeDigitada > qtdeEstoque) {
        toastFire('0|Quantidade solicitada maior do que o estoque disponível.', Toast);
        $("#grade" + produto + "_" + cor + "_" + tamanho + " .qtdeItem").val('');
    }

    $("#grade" + produto + "_" + cor + " .qtdeItem").each(function (index) {
        qtdeTotalCor += (parseInt($(this).val()) > 0) ? parseInt($(this).val()) : 0;
        valorTotalCor += (parseInt($(this).val()) > 0) ? parseInt($(this).val()) * preco : 0;
    });
    $("#qtdeTotalCor" + produto + "_" + cor).val((qtdeTotalCor) ? qtdeTotalCor : '');
    var valorTotalCor = valorTotalCor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    $("#valorTotalCor" + produto + "_" + cor).val((valorTotalCor) ? valorTotalCor : '');

    // Calcula total geral
    var qtdeTotal = 0;
    var valorTotal = 0;
    $("#grade" + produto + " .qtdeItem").each(function (index) {
        qtdeTotal += (parseInt($(this).val()) > 0) ? parseInt($(this).val()) : 0;
        valorTotal += (parseInt($(this).val()) > 0) ? parseInt($(this).val()) * preco : 0;
    });
    $("#qtdeTotal" + produto).val((qtdeTotal) ? qtdeTotal : '');
    var valorTotal = valorTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    $("#valorTotal" + produto).val((valorTotal) ? valorTotal : '');
}

$(document).on('click', '#formCarrinho .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    var produto = $(this).attr('data-produto');
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span> Adicionando no carrinho ...').attr('disabled', true);
            },
            success: function (response) {
                console.log(response);
                result = response.split('|');
                toastFire(response, Toast);
                btn.html(btnTextoOriginal).attr('disabled', false);
                $('#headerTotalItensPedido').html(result[2]);

                $.ajax({
                    type: "POST",
                    context: this,
                    url: "pedidos/grade/"+produto,
                    success: function (result) {
                        $('#contentGrade').html(result);
                    }
                });
            }
        });
    }
});

$(document).on('click', '.formCarrinhoFinaliza .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    var produto = $(this).attr('data-produto');

    if (form.find('.condicao_pagamento').val() == '') {
        toastFire('0|Selecione uma condição de pagamento.', Toast);
    }

    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span> Finalizando ...').attr('disabled', true);
            },
            success: function (response) {
                console.log(response);
                result = response.split('|');
                if (result[0] == 0) {
                    toastFire(response, Toast);
                    btn.html(btnTextoOriginal).attr('disabled', false);
                } else {
                    location.href = 'pedidos/obrigado';
                }

            }
        });
    }
});

$(document).on('click', '.btnExcluirProdutoCarrinho', function(e) {
    e.preventDefault();
    var pCodigo = $(this).attr('data-codigo');
    var pUrl = $(this).attr('href');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover o produto do seu pedido!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#206bc4',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "POST",
                data: {codigo: pCodigo}, //pCodido em enc()
                url: pUrl,
                success: function (response) {
                    result = response.split('|');
                    console.log(pCodigo, response, result);
                    if (parseInt(result[0]) == 1) {
                        $('#row' + pCodigo).remove();
                        toastFire(response, Toast);
                        console.log($('.row-item').length);
                        if ($('.row-item').length == 0) location.reload();
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

function atualizaCarrinho(item, origem) {
    var group = item.closest('.input-group');
    var input = group.find('.input-qtde');
    var qtde = parseInt(input.val());
    var qtdeOld = parseInt(input.attr('oldvalue'));
    var acao = item.attr('data-acao');
    var codigo = item.attr('data-codigo');
    var refresh = item.attr('data-refresh');

    if (qtde > qtdeOld) {
        acao = 'add';
    } else if (qtde < qtdeOld) {
        acao = 'del';
    }

    if (acao == 'add') {
        if (origem == 'click') {
            qtde++;
        }
        input.val(qtde);
    } else if (acao == 'del') {
        if (origem == 'click') {
            qtde--;
        }
        input.val((qtde<1) ? 0 : qtde);
    } else {
        input.val(qtdeOld);
    }
    qtde = parseInt(input.val());

    console.log('-->', qtde, acao, codigo);

    $.ajax({
        type: "POST",
        data: {qtde: qtde, acao: acao, codigo: codigo }, //pCodido em enc()
        url: 'pedidos/update',
        success: function (response) {
            result = response.split('|');
            if (parseInt(result[0]) == 1) {
                toastFire(response, Toast);
                if (result[2] == 'refresh') {
                    location.reload();
                } else {
                    $('#valorTotalProduto').html(result[2]);
                    input.val(result[3]);
                    input.attr('oldvalue', result[3]);
                }
                if (refresh == 'true') location.reload(); // usado no carrinho para atualizar cada alteracao de quantidade
            } else {
                input.val(result[3]);
                Swal.fire({
                    text: result[1],
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
            }
        }
    });
}

function setOldQtde(element) {
    element.attr("oldvalue", element.val());
}

function onChangeQtde(element) {
    element.attr("value", element.attr("oldvalue") );
}

$(document).on('blur', '.input-qtde', function(e) {
    e.preventDefault();
    if ($(this).val() != '' && parseInt($(this).val()) >= 0 && parseInt($(this).val()) != parseInt($(this).attr('oldvalue')))
        atualizaCarrinho($(this), 'blur');
    else
        $(this).val($(this).attr('oldvalue'));
});

$(document).on('click', '.btnUpdateProdutoCarrinho', function(e) {
    e.preventDefault();
    atualizaCarrinho($(this), 'click');
});

// para atualizar a página de detalhes do produto ao fecha o Off Canvas
if ($('#offCanvasCarrinho').length > 0) {
    $('#offCanvasCarrinho').on('hidden.bs.offcanvas', function (e) {
        location.reload();
    });
}
$(document).on('click', '#formRegioes .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirRegioes', function(e) {
    e.preventDefault();
    confirmaExcluir("regioes/excluir", $(this).attr('data-codigo'));
});
$(document).on('click', '#formTiposUsuarios .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirTiposUsuarios', function(e) {
    e.preventDefault();
    confirmaExcluir("tipos-de-usuarios/excluir", $(this).attr('data-codigo'));
});